//import
import './build/pagetop.js';
import './build/anchor.js';
import './build/qaToggle.js';

/**============================================================
*   [記事詳細] メインスライダー
*   target : .p-post-main-slider
============================================================*/
import PageMainSlider from './build/voiceSlider.js';
const PageMainSliderElem = document.getElementsByClassName('p-ohakaerabi-voice');
const createPageMainSliderObj = () => {
  if (!PageMainSliderElem.length) return;
  for (let i = 0; i < PageMainSliderElem.length; i++) {
    new PageMainSlider(PageMainSliderElem[i], i);
  }
}
document.addEventListener('DOMContentLoaded', createPageMainSliderObj, false);


document.addEventListener('DOMContentLoaded', function() {
  // ハンバーガーメニュー
  const menuIcon = document.querySelector('.l-nav-hamburger-menu-icon');
  const mobileNav = document.querySelector('.l-nav-wrapper');

  function toggleMenu() {
    menuIcon.classList.toggle('active');
    mobileNav.classList.toggle('active');

    if (menuIcon.classList.contains('active')) {
        menuIcon.classList.add('close');
    } else {
        menuIcon.classList.remove('close');
    }
  }

  menuIcon.addEventListener('click', toggleMenu);

  const navLinks = mobileNav.querySelectorAll('a');
    navLinks.forEach(link => {
    link.addEventListener('click', toggleMenu);
  });

  const header = document.querySelector('#js-header');

  window.addEventListener('scroll', () => {
      // たとえば、50px以上スクロールされた場合にクラスを変更
      if (window.scrollY > 50) {
          header.classList.add('scrolled');
      } else {
          header.classList.remove('scrolled');
      }
  });

});
